<template>

  <div class="edit-plan">
    <!-- 返回按钮 -->
    <enfold-uc>
      <template slot="up">
        <div class="comback">
          <div class="comback_icon" @click="comback">
            <!-- <i class="el-icon-arrow-left"></i> -->
          </div>
          <div class="titd flex-b-c">
            <span class="tit" v-if="plantype==0">{{$t('schedule.loop')}}</span>
            <span class="tit" v-if="plantype==1">{{$t('schedule.timpingPlay')}}</span>
            <span class="tit" v-if="plantype==2">{{$t('schedule.emerPlay')}}</span>
            <div v-if="plantype==1" style="width: calc(100% - 80px); font-size:24px" class="flex-a-c">
              <el-tooltip class="item" effect="dark" :content="$t('csce1')" placement="top">
                <img src="@imgpub/sel_template.png" @click="selectTemplate" class="p-icon" alt />
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('csce2')" placement="top">
                <img src="@imgpub/save_template.png" @click="saveTemplate" class="p-icon" alt />
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('csce3')" placement="top">
                <el-upload action accept=".xlsx, .xls" :http-request="getExcel" :show-file-list="false" style="height: 26px;">
                  <img src="@imgpub/import.png" class="p-icon" alt />
                </el-upload>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('csce4')" placement="top">
                <!-- <i class="el-icon-printer" @click="exportTemplate"></i> -->
                <img src="@imgpub/export.png" @click="exportTemplate" class="p-icon" alt />
              </el-tooltip>

              <!-- <el-button size="mini" type="primary" @click="selectTemplate" round>选择模板</el-button>
              <el-button size="mini" type="primary" @click="saveTemplate" round :disabled="!this.$pstore.state.finaldata.length">保存</el-button>
              <el-button size="mini" type="primary" @click="saveTemplate" round :disabled="!this.$pstore.state.finaldata.length">导出</el-button> -->
            </div>

          </div>
        </div>
      </template>
      <template slot="center">
        <div class="iconlist">
          <ul class="icon">
            <li @click="dialogTableVisible = true;add()" class="add"></li>
            <li @click="copyitems()" class="copyitems"></li>
            <li @click="clearitems()" class="clearitems"></li>
            <li @click="moveup()" class="moveup"></li>
            <li @click="movedown()" class="movedown"></li>
          </ul>
        </div>

        <!-- 左侧的节目列表 -->
        <div class="planlist">
          <!-- 节目封装成组件，有一个节目读取一个组件 -->
          <!-- <program-items v-for="planid in planids" v-bind:planid="planid" :key="planid.id" class="citems"></program-items> -->
          <template v-if="plantype==0">
            <div class="itemsgroup" v-if="this.type==0">
              <template v-if="this.$pstore.state.finaldata.length==0">
                <!-- 添加节目区域 -->
                <div class="add-plan" @click="dialogTableVisible = true;add()">
                  <div class="addp"><img src="~@/assets/images/public/public_add.png" /></div>
                  <div class="addp txt">{{$t('schedule.addPlay')}}</div>
                </div>
              </template>
              <program-items v-for="(planid,index) in $pstore.state.finaldata" v-bind:planid="planid" :key="index" v-bind:index="index" @click.native="clickitem(index)" :plantype="plantype" v-bind:class="{ active: index===$pstore.state.currentindex }" class="citems">
              </program-items>
              <template v-if="this.$pstore.state.finaldata.length!==0">
                <div class="add-plan" @click="dialogTableVisible = true;add()">
                  <div class="addp"><img src="~@/assets/images/public/public_add.png" /></div>
                  <div class="addp txt">{{$t('schedule.addPlay')}}</div>
                </div>
              </template>
            </div>
            <div class="itemsgroup" v-if="this.type==1">
              <program-list-items v-for="(planid,index) in $pstore.state.finaldata" :plantype="plantype" v-bind:planid="planid" :key="index" v-bind:index="index" @click.native="clickitem(index)" class="listitems" :currentindex="$pstore.state.currentindex"></program-list-items>
            </div>
          </template>

          <!-- 定时播放类型 -->
          <template v-if="plantype==1">
            <div class="itemsgroup" v-if="this.type==0">
              <template v-if="this.$pstore.state.finaldata.length==0">
                <!-- 添加节目区域 -->
                <div class="add-plan" @click="dialogTableVisible = true;add()">
                  <div class="addp"><img src="~@/assets/images/public/public_add.png" /></div>
                  <div class="addp txt">{{$t('schedule.addPlay')}}</div>
                </div>
              </template>
              <program-items v-for="(planid,index) in $pstore.state.finaldata" v-bind:planid="planid" :key="index" v-bind:index="index" @click.native="clickitem(index)" v-bind:class="{ active: index===$pstore.state.currentindex }" class="citems">
              </program-items>
              <!-- 添加节目区域 -->
              <template v-if="this.$pstore.state.finaldata.length!==0">
                <div class="add-plan" @click="dialogTableVisible = true;add()">
                  <div class="addp"><img src="~@/assets/images/public/public_add.png" /></div>
                  <div class="addp txt">{{$t('schedule.addPlay')}}</div>
                </div>
              </template>
            </div>

            <div class="itemsgroup" v-if="this.type==1">
              <program-list-items v-for="(planid,index) in $pstore.state.finaldata" v-bind:planid="planid" :key="index" v-bind:index="index" @click.native="clickitem(index)" class="listitems" :currentindex="$pstore.state.currentindex">
              </program-list-items>
            </div>
          </template>
          <!-- 紧急插播 -->
          <template v-if="plantype==2">
            <div class="itemsgroup" v-if="this.type==0">
              <template v-if="this.$pstore.state.finaldata.length==0">
                <!-- 添加节目区域 -->
                <div class="add-plan" @click="dialogTableVisible = true;add()">
                  <div class="addp"><img src="~@/assets/images/public/public_add.png" /></div>
                  <div class="addp txt">{{$t('schedule.addPlay')}}</div>
                </div>
              </template>
              <program-items v-for="(planid,index) in $pstore.state.finaldata" v-bind:planid="planid" :key="index" v-bind:index="index" @click.native="clickitem(index)" v-bind:plantype="plantype" v-bind:class="{ active: index===$pstore.state.currentindex }" class="citems"></program-items>

              <template v-if="this.$pstore.state.finaldata.length!==0">
                <div class="add-plan" @click="dialogTableVisible = true;add()">
                  <div class="addp"><img src="~@/assets/images/public/public_add.png" /></div>
                  <div class="addp txt">{{$t('schedule.addPlay')}}</div>
                </div>
              </template>
            </div>
            <div class="itemsgroup" v-if="this.type==1">
              <program-list-items v-for="(planid,index) in $pstore.state.finaldata" v-bind:plantype="plantype" v-bind:planid="planid" :key="index" v-bind:index="index" @click.native="clickitem(index)" class="listitems" :currentindex="$pstore.state.currentindex"></program-list-items>
            </div>
          </template>

          <div class="bottomgroup">
            <div class="botspan">
              <div><span class="tit" v-if="plantype==0">{{$t('schedule.loop')}}</span>
                <span class="tit" v-if="plantype==1">{{$t('schedule.timpingPlay')}}</span>
                <span class="tit" v-if="plantype==2">{{$t('schedule.emerPlay')}}</span>
              </div>
            </div>
            <!-- 下方两个小图标 -->
            <div class="bottom-icon">
              <ul class="bottom-ul">
                <!-- <li @click="changeToThumb()" :class="{list_sel:this.type==0,list_nor:this.type==1}"
									class="bleft"></li>
								<li @click="changeToList()" :class="{chart_nor:this.type==0,chart_sel:this.type==1}">
								</li> -->
                <li @click="changeToThumb()" :class="{chart_nor:this.type==1,chart_sel:this.type==0}" class="bleft"></li>
                <li @click="changeToList()" :class="{list_sel:this.type==1,list_nor:this.type==0}">
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </enfold-uc>
    <form-dialog :title="$t('schedule.selectProgram')" :dialogVisible="dialogTableVisible" @closeDialog="closeDialog" dWidth="860px" top="10vh">
      <div class="el-dialog-div">
        <enfold-cd>
          <template slot="center">
            <el-table style="width: 100%" ref="multipleTable" :data="play_data" height="100%" @row-click="selectRow" @selection-change="selectionLineChangeHandle" :row-key="getRowKey" v-loading="loading">
              <el-table-column type="selection" :reserve-selection="true"></el-table-column>
              <template v-for="(item,index) in tableHead">
                <el-table-column :prop="item.column_name" :label="$t(item.column_comment)" :key="index" v-if="item.column_name === 'pimg'">
                  <template slot-scope="scope"><img :src="scope.row.pimg" class="planimg" /></template>
                </el-table-column>
                <!-- 字段名是截图则不显示 拿出来单独显示 -->
                <el-table-column :prop="item.column_name" :label="$t(item.column_comment)" :key="index" v-if="item.column_name != 'pimg'"></el-table-column>
              </template>
            </el-table>
          </template>

          <template slot="down">
            <!-- 控制翻页的部分 -->
            <div slot="footer" class="footer">
              <div class="search">
                <el-input :placeholder="$t('schedule.keyWords')" style="width:100%" size="mini" v-model="searchData">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="search()"></i>
                </el-input>
              </div>
              <div class="control">
                <el-pagination align='center' @current-change="handleCurrentChange" v-show="totalCount>12" :current-page="current_page" :page-sizes="[12]" :page-size="pagesize" background layout="prev,pager,next" :total="totalCount">
                </el-pagination>
              </div>
              <div class="confirm_button">
                <el-button size="mini" @click="confirm();dialogTableVisible = false" round type="primary">{{$t('terminal.confirm')}}</el-button>
              </div>
            </div>
          </template>
        </enfold-cd>
      </div>

    </form-dialog>

    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('schedule.delPro')">
      <div class="dd-dialog">{{$t('schedule.delProTip')}}</div>
    </del-dialog>
    <form-dialog :dialogVisible="dialogTemplateVisible" @closeDialog="templateCloseDialog" :title="{'add':$t('csce1'),'select':$t('csce1')}[temModel]">
      <template v-if="temModel == 'add'">
        <div>
          <el-input v-model="templateName" :placeholder="$t('csce5')"></el-input>
        </div>
      </template>
      <template v-else-if="temModel == 'select'">
        <div class="temp-list">
          <div v-for="item in templateList" :key="item.id" class="temp-item" :class="{'item-active':item.id == currentId}" @click="selTemp(item.id)">
            <span>{{item.name}}</span>
            <i class="el-icon-close del" @click="delTemp(item.id)"></i>
          </div>
        </div>
      </template>
      <div class="dialog-footer">
        <el-button round @click="temCancel">{{ $t('csce6') }}</el-button>
        <el-button round type="primary" @click="confirmTemp" :disabled="(temModel == 'add' && !templateName) || (temModel == 'select' && currentId == -1)">{{$t('csce7')}}</el-button>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import ProgramItems from "./items/ProgramItems.vue"
import ProgramListItems from "./items/ProgramListItems.vue"
import EnfoldUc from "@/components/basics/EnfoldUC"
import DelDialog from './DelDialog.vue'
import EnfoldCd from '@/components/basics/EnfoldCD'
import FormDialog from '@/components/basics/FormDialog'
import superClone from '@/assets/scripts/superClone.js';
// eslint-disable-next-line no-unused-vars
import XLSX from 'xlsx';
// eslint-disable-next-line no-unused-vars
import { weekFormatting, reWeekFormatting, dateFormat } from "@/assets/scripts/dateFormatting";
import {
  uriEncode
} from "@/assets/scripts/uriEncode";

const mapList = {
  action: "action",
  play_id: "节目id",
  name: "节目名称",
  startTime: "开始时间",
  endTime: "结束时间",
  isDateLimit: "有效日期",
  dateStart: "开始日期",
  dateEnd: "结束日期",
  isWeekLimit: "有效星期",
  validWeek: "星期",
  playCount: "连续循环次数",
  allNumber: "总播放次数",
};

export default {
  name: "EditPlan",
  components: {
    // PlanDialog
    ProgramItems,
    ProgramListItems,
    EnfoldUc,
    DelDialog,
    EnfoldCd,
    FormDialog
  },
  props: {
    plantype: {
      type: Number
    }
  },
  data() {
    return {
      pagesize: 12,
      totalCount: 0,
      current_page: 1,
      loading: false,
      play_data: [],
      searchData: null,
      planids: [],
      //三种发布模式，0为循环，1为定时，2为紧急插播
      //plantype: 1,
      //当前被选中的items的index
      curindex: 0,
      //节目显示的类型，缩略图为0 列表为1
      type: 0,
      dialogTableVisible: false,
      dialogFormVisible: false,
      DelDialogVisible: false,
      dialogTemplateVisible: false,
      currentId: -1,
      templateList: [],
      temModel: "",
      templateName: "",
      tableHead: [{
        column_name: "pimg",
        column_comment: "schedule.screenshot"
      },
      {
        column_name: "name",
        column_comment: "schedule.proName"
      },
      {
        column_name: "group_name",
        column_comment: "schedule.structure"
      },
      {
        column_name: "size_remark",
        column_comment: "schedule.resolution"
      },
      {
        column_name: "create_time",
        column_comment: "schedule.createTime"
      }
      ]
    }
  },
  methods: {
    selectTemplate() {
      this.temModel = "select"
      this.$http.post("/admin/publish/listTemplate", {}, (data) => {
        this.templateList = data;
      })
      this.dialogTemplateVisible = true;
    },
    selTemp(id) {
      this.currentId = id;
    },
    delTemp(id) {
      this.$http.post("/admin/publish/delTemplate", {
        id
      }, data => {
        if (data.length === 0) {
          this.$http.post("/admin/publish/listTemplate", {}, (data) => {
            this.templateList = data;
          })
          this.currentId = -1;
          this.$msg({ type: 'success', message: this.$t('csce19') });
        } else {
          this.$msg({ type: 'success', message: this.$t('csce20') });
        }
        console.log("data", data);
      })
    },
    saveTemplate() {
      this.temModel = "add";
      this.dialogTemplateVisible = true;
    },
    importTemplate() {

    },
    getExcel(file) {
      let reader = new FileReader();
      reader.onload = async (e) => {
        let data = e.target.result;
        let workbook = XLSX.read(data, { type: 'binary' });
        console.log(workbook);
        let xlsxList = XLSX.utils.sheet_to_json(workbook.Sheets.Sheet1, { raw: false });
        console.log(xlsxList);
        let scheduleList = xlsxList.map((x) => {
          let obj = {};
          for (let key in mapList) {
            switch (key) {
              case "validWeek": {
                const validWeek = x[mapList[key]] ? x[mapList[key]].split(',') : [];
                obj[key] = weekFormatting(validWeek)
              } break;
              case "isWeekLimit":
              case "isDateLimit": {
                obj[key] = x[mapList[key]] === "有效" ? true : false;
              } break;
              // case "play_id":
              case "play_id":
              case "playCount":
              case "allNumber": {
                obj[key] = parseInt(x[mapList[key]]);
              } break;
              default:
                obj[key] = x[mapList[key]];
                break;
            }
          }
          return obj;
        });

        let play_ids = [... new Set(scheduleList.map((s) => s.play_id))];
        let playList = [];
        await this.$http.post("/admin/play/detailList", {
          play_ids: play_ids.join(','),
        }, data => {
          playList = play_ids.map((v) => {
            return data.find(d => d.id === v);
          });
        });

        this.$pstore.commit("initTemplate", {
          playList: playList,
          scheduleList: scheduleList
        })
      }
      reader.readAsBinaryString(file.file);
    },
    exportTemplate() {
      this.$pstore.commit("getTemplateData");
      let templateList = superClone(this.$pstore.state.templateData);

      if (templateList.length === 0) {
        this.$msg({ type: "warning", message: this.$t('csce22') });
        return;
      }
      // let data = {};
      // templateList.forEach(t => {
      //   !Array.isArray(data[t.name]) && (data[t.name] = []);
      //   data[t.name].push(t);
      // });
      // console.log(data);

      let list = templateList.map((t) => {
        t.validWeek = reWeekFormatting(t.validWeek).join(',');
        t.isWeekLimit = t.isWeekLimit ? "有效" : "无效";
        t.isDateLimit = t.isDateLimit ? "有效" : "无效";
        return Object.values(t);
      });

      const data = [Object.values(mapList), ...list];

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `定时播放_${dateFormat(new Date())}.xlsx`);
      this.$msg({ type: "success", message: this.$t('csce25') });
    },
    templateCloseDialog() {
      this.dialogTemplateVisible = false;
    },
    temCancel() {
      this.currentId = -1;
      this.dialogTemplateVisible = false;
    },
    confirmTemp() {
      switch (this.temModel) {
        case "add":
          if (!this.templateName) {
            this.$msg({
              type: "warning",
              message: "请输入模板名称"
            })
          } else {
            //this.getTemplateData();
            this.$pstore.commit("getTemplateData");
            this.$http.post('/admin/publish/addTemplate', {
              name: this.templateName,
              group_id: this.$cookies.get("group_id"),
              play_ids: this.$pstore.state.templateIds,
              play_schedule: uriEncode(this.$pstore.state.templateData)
            }, data => {
              if (data.num) {
                this.$msg({
                  type: "success",
                  message: this.$t('csce26')
                })
              }
            })
            this.dialogTemplateVisible = false;
          }
          break;
        case "select":
          if (this.currentId) {
            this.$http.post("/admin/publish/detailsTemplate", {
              id: this.currentId
            }, data => {
              this.$pstore.commit("initTemplate", data)
            })
            this.dialogTemplateVisible = false;
          }
          break;
      }
    },
    selectRow(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row,
        true);
    },
    add() {
      //const limit = 10;
      this.loading = true
      const group_ids = sessionStorage.getItem('group_ids');
      this.$http.post("/admin/play/list", {
        //limit,
        page: this.current_page,
        group_ids
      }, info => {
        this.totalCount = info.count ? parseInt(info.count) : 0;
        this.play_data = info.list ? info.list : [];
        this.current_page = info.page ? info.page : 1;
        this.loading = false
        //this.play_data = (info.page+1).list
        //console.log("states--->", this.status)
        //console.log("data----->", this.play_data)
        //console.log("page----->", this.current_page);
        //console.log("count---->", this.totalCount)
      });
    },
    //翻页记忆
    getRowKey(row) {
      return row.id
    },
    //关闭窗口清楚记忆的选项
    closeDialog() {
      this.$refs.multipleTable.clearSelection()
      this.dialogTableVisible = false;
    },
    // // 删除节目
    // deleteitems() {
    // 	this.$pstore.commit('deleteitems', this.curindex)
    // 	this.$pstore.commit('confirmCurrentindex', this.curindex)
    // 	//this.curindex -= 1
    // },
    //复制节目
    copyitems() {
      if (this.$pstore.state.finaldata.length == 0) {
        this.$msg({
          showClose: true,
          message: this.$t('schedule.noProgram'),
          type: 'warning'
        });
      } else {
        this.$pstore.commit('copyitems')
      }

    },
    //下移动节目
    movedown() {
      if (this.$pstore.state.currentindex < this.$pstore.state.finaldata.length - 1) {
        this.$pstore.commit('movedown', this.curindex)
      } else {
        this.$msg({
          showClose: true,
          message: this.$t('schedule.moveDown'),
          type: 'warning'
        });
      }

    },
    moveup() {
      if (this.$pstore.state.currentindex > 0) {
        this.$pstore.commit('moveup', this.curindex)
      } else {
        this.$msg({
          showClose: true,
          message: this.$t('schedule.moveUp'),
          type: 'warning'
        });
      }
    },
    search() {
      if (this.searchData == null) {
        this.$msg({
          showClose: true,
          message: this.$t('schedule.keyWords'),
          type: 'warning'
        });
      } else {
        const group_ids = sessionStorage.getItem('group_ids');
        this.$refs.multipleTable.clearSelection();
        this.$http.post("/admin/play/list", {
          page: this.current_page,
          group_ids,
          key_word: this.searchData
        }, info => {
          this.totalCount = Number(info.count);
          this.play_data = info.list;
          this.current_page = info.page;
        });
      }
    },
    clearitems() {
      if (this.$pstore.state.finaldata.length == 0) {
        this.$msg({
          showClose: true,
          message: this.$t('schedule.noProgram'),
          type: 'warning'
        });
      } else {
        this.DelDialogVisible = true;
      }
      // this.$pstore.commit('clearitems')
      this.$forceUpdate()
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$pstore.commit('clearitems')
      }
      this.delProgramIds = "";
      this.DelDialogVisible = false;
    },
    // 取消选择
    // toggleSelection(rows) {
    // 	if (rows) {
    // 		rows.forEach(row => {
    // 			this.$refs.multipleTable.toggleRowSelection(row);
    // 		});
    // 	} else {
    // 		this.$refs.multipleTable.clearSelection();
    // 	}
    // },
    // 处理页面改变时
    handleCurrentChange(val) {
      this.current_page = val;
      this.add()
    },
    //确定时遍历对象获取id
    confirm() {
      for (var i = 0; i < this.planids.length; i++) {
        console.log('id:' + this.planids[i].id)
      }
      //点击确定提交对象到vuex中
      if (this.plantype == 0) {
        //循环播放
        this.$pstore.commit('increment', this.planids)
      } else if (this.plantype == 1) {
        //定时播放
        this.$pstore.commit('setTimePlanData', this.planids)
      } else if (this.plantype == 2) {
        this.$pstore.commit('setUrgencyPlan', this.planids)
      }

      this.$refs.multipleTable.clearSelection()
    },
    //选择框变化时，记录变化的那一行的对象
    selectionLineChangeHandle(val) {
      this.planids = val
    },

    //点击、选中所选的items 并且提交当前index到vuex中和PlayPlan组件共享状态
    clickitem(key) {
      this.$forceUpdate();
      this.curindex = key
      this.$pstore.commit('confirmCurrentindex', key);
    },
    changeToThumb() {
      this.type = 0;
      this.$emit("thumbToList", 0);
    },
    changeToList() {
      this.type = 1;
      this.$emit("thumbToList", 1);
    },
    comback() {
      this.$router.push({
        path: 'IssueManage'
        //path: '../IssueManage'
      })
      // this.$pstore.commit('clearitems')
    }
  }
}
</script>

<style lang="scss" scoped>
.temp-list {
  width: 100%;
  height: 300px;
  overflow-y: auto;
  .temp-item {
    width: 100%;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .del {
      font-size: 20px;
    }
  }
  .item-active {
    background-color: #86eae7;
  }
}
.edit-plan {
  height: 100%;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
  padding: 10px 60px 0 40px;
}
.comback {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
}

.titd {
  width: 100%;
  margin-left: 30px;
  // flex-basis: 90%;
  // margin-left: 12%;
  // display: flex;
  // align-items: center;
  // justify-content: space-around;
  .p-icon {
    width: 26px;
    height: 26px;
    cursor: pointer;
  }
}

.titd::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.comback::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.tit {
  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 16px;
  height: 16px;
  color: #617883;
}

.comback_icon {
  background-color: #dcdfe6;
  background-image: url(~@/assets/images/public/public_back2.png);
  background-size: 100%;
  background-position: center;
  text-align: center;
  width: 30px;
  height: 30px;
  /* font-size: 2vw; */
  /* line-height: 25px; */
  /* margin-left: 1%; */
  /* margin-top: 1%; */
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.comback_icon:hover {
  cursor: pointer;
}

.comback_icon::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.add {
  background-image: url(~@/assets/images/release/release_add.png);
}

.copyitems {
  background-image: url(~@/assets/images/release/release_copy.png);
}

.clearitems {
  background-image: url(~@/assets/images/release/release_delete.png);
}

.moveup {
  background-image: url(~@/assets/images/release/release_up.png);
}

.movedown {
  background-image: url(~@/assets/images/release/release_down.png);
}

.icon {
  /* margin: 20px auto; */
  /* box-sizing: border-box; */
  width: 88%;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  list-style: none;
  justify-content: space-between;
}

.icon li {
  flex-basis: 14.5%;
  border-radius: 4px;
  border: solid 1px #dcdfe6;
  background-size: 100%;
  background-position: center;
}

/* .icon li:hover{
		cursor: pointer;
	} */
.iconlist {
  height: 35px;
  /* background-color: #86EAE7; */
  position: relative;
  text-align: center;
  margin: 5px 0 5px 0;
  /* border-bottom: 1px solid black; */
}

.active {
  background-color: aqua;
}

.planlist {
  width: 100%;
  height: calc(100% - 50px);
  /* border: 1px solid black; */
  /* border-right: 1px solid black; */
  /* overflow-y: scroll; */
}

.bottomgroup {
  display: flex;
  margin: 0 auto;
}

.botspan {
  position: fixed;
  left: 0;
  white-space: nowrap;
  padding: 2px 6px 2px 2px;
  bottom: 3%;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0vw 15px 15px 0vw;
  text-align: center;
  box-shadow: 0 0 5px 1px #999;
}

.botspan span {
  font-family: PingFang-SC-Regular;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0vh;
  color: rgba(47, 179, 255, 1);
}

.botspan div {
  text-align: center;
}

.botspan div::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.citems:hover {
  cursor: pointer;
}

.bottom-icon {
  flex-basis: 50%;
  padding-left: 50%;
}

.bottom-ul {
  margin-right: 10%;
  width: 50%;
  display: flex;
  justify-content: space-between;
}

.bottom-ul li:hover {
  cursor: pointer;
}

.bottom-icon ul {
  float: right;
  padding-right: 0%;
}

.add-plan {
  text-align: center;
  border-radius: 5px;
  margin: 5px auto;
  width: 98%;
  height: 60px;
  background-color: #edfbff;
  color: #2fb3ff;
  display: flex;
  flex-direction: column;
  /* 	position: fixed;
		bottom: 4%; */
}

.add-plan:hover {
  cursor: pointer;
}

.planimg {
  width: 96px;
  height: 54px;
}

.el-dialog-div {
  height: 65vh;
  overflow: auto;
}

.citems:hover {
  background-color: #86eae7;
}

.itemsgroup {
  /* border-right: 1px solid gray; */
  width: 100%;
  height: 92%;
  overflow-y: auto;
}

.listitems {
  // height: 30px;
  display: flex;
  align-items: center;
}

.search {
  /* margin-top: -4%; */
  flex-basis: 20%;
  text-align: center;
  /* border: 1px solid black; */
  /* margin-top: 2px; */
  float: left;
}

.confirm_button {
  flex-basis: 20%;
  float: right;
  text-align: center;
}

.control {
  /* margin: 0 auto; */
  flex-basis: 60%;
  /* border: 1px solid black; */
  float: left;
}

.footer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  /* justify-content: space-between */
  /* border: 1px solid black; */
}

.addp {
  margin: 0 auto;
  height: 50%;
}

.addp img {
  width: 60%;
}

.list_sel {
  background-image: url(~@/assets/images/public/public_list_sel.png);
}

.list_nor {
  background-image: url(~@/assets/images/public/public_list_nor.png);
}

.chart_sel {
  background-image: url(~@/assets/images/public/public_chart_sel.png);
}

.chart_nor {
  background-image: url(~@/assets/images/public/public_chart_nor.png);
}

.bottom-icon li {
  float: left;
  width: 35px;
  height: 35px;
  background-size: 100%;
  background-position: center;
}

.txt::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}
/deep/ .el-table__header-wrapper {
  .cell {
    font-size: 18px;
    color: #2fb3ff;
  }

  th:last-child > .cell {
    text-align: center;
  }
}
</style>
